import { useQuery } from "@tanstack/react-query";
import axios from "../axios";

const useGetBalance = (sellerId) => {
  return useQuery({
    queryKey: ["balance", sellerId],
    queryFn: async () => {
      console.log(`🔄 [useGetBalance] Query function executing for sellerId: ${sellerId}`);
      
      if (!sellerId) {
        console.log("⏸️ [useGetBalance] sellerId is falsy, returning null");
        return null;
      }

      try {
        console.log(`📡 [useGetBalance] Making API request to /api/balance/${sellerId}`);
        const response = await axios.get(`/api/balance/${sellerId}`);
        
        console.log(`✅ [useGetBalance] API request successful for sellerId: ${sellerId}`, {
          status: response.status,
          data: response.data
        });
        
        return response.data;
      } catch (error) {
        console.error(`❌ [useGetBalance] API request failed for sellerId: ${sellerId}`, {
          error: error.message,
          status: error.response?.status,
          data: error.response?.data
        });
        throw error; // Re-throw to let React Query handle the error
      }
    },
    enabled: !!sellerId,
    staleTime: 30000,
    
    // Additional React Query event handlers for debugging
    onSuccess: (data) => {
      console.log(`🎯 [useGetBalance] onSuccess for sellerId: ${sellerId}`, data);
    },
    onError: (error) => {
      console.error(`💥 [useGetBalance] onError for sellerId: ${sellerId}`, error);
    },
    onSettled: (data, error) => {
      console.log(`⚡ [useGetBalance] onSettled for sellerId: ${sellerId}`, {
        data,
        error: error?.message
      });
    },
  });
};

export default useGetBalance;